import { render, staticRenderFns } from "./InsurancePayment.vue?vue&type=template&id=77c0d173&scoped=true&"
import script from "./InsurancePayment.ts?vue&type=script&lang=ts&"
export * from "./InsurancePayment.ts?vue&type=script&lang=ts&"
import style0 from "./InsurancePayment.vue?vue&type=style&index=0&id=77c0d173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c0d173",
  null
  
)

export default component.exports